import { Translate as t } from '../../config/Translate';

// 사용자 추가·수정 화면이 같이 쓰는 칸 이름 (IMP-475 U-07)
// 키는 t('...') 리터럴로 둔다 — src 전역 키 존재 가드(imp272.i18n.test.js)는 리터럴 호출만 수집한다.
const USER_FIELD_LABELS = {
    adminType: () => t('user.field.authority'),
    function: () => t('user.field.role'),
    csPortalLink: () => t('service.label.csPortalLink'),
    isUse: () => t('user.field.isUse'),
    permAdminAccess: () => t('user.field.adminAccess'),
    isEmail: () => t('notification.label.receiveEmail'),
    isTypeChange: () => t('product.button.typeChange'),
    isCreateLicense: () => t('user.field.createLicense'),
    isLicenseDownload: () => t('license.button.keyFileDownload'),
    isSetWarranty: () => t('user.field.standardWarranty'),
    dealerType: () => t('license.field.dealerType'),
    rguardSettingLanguage: () => t('common.label.systemLanguage'),
    rguardSettingEmailReportLanguage: () => t('common.field.email') + " / " + t('common.label.report') + " - " + t('common.field.language'),
};

export const userFieldLabel = (name) => (USER_FIELD_LABELS[name] ? USER_FIELD_LABELS[name]() : name);

export const dealerTypeOptions = () => [
    { code: 'internal', title: t('license.label.internalDealer') },
    { code: 'external', title: t('license.label.externalDealer') },
];
